import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

@NgModule({
  imports: [
    CommonModule,
  ]
})
export class UserModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/user/user.module.ts